import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const blogSubscriberPageSlice = createSlice({
    name: "blogSubscriberPageSlice",
    initialState,
    reducers: {
        setBlogSubscriberPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setBlogSubscriberCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setBlogSubscriberTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setBlogSubscriberTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetBlogSubscriberPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setBlogSubscriberPageLimit,
    setBlogSubscriberCurrentPage,
    setBlogSubscriberTotalCount,
    setBlogSubscriberTotalPages,
    resetBlogSubscriberPagination,
} = blogSubscriberPageSlice.actions;

export default blogSubscriberPageSlice.reducer;
